import { ICompileService, IServiceProvider, Injectable } from "angular";
import { ColDef } from "./colDef";
import { Dictionary } from "lodash";

export const vsServiceName = "columnDefinitionSetService";
export const vsProviderName = `${vsServiceName}Provider`;

export class ColumnDefinitionSetServiceProvider implements IServiceProvider {
  $get: any = [
    "$injector",
    ($injector: angular.auto.IInjectorService) => {
      const columnDefinitionSets: Dictionary<ColDef[]> = Object.entries(
        this.columnDefinitionSets
      ).reduce((result, next) => {
        const name = next[0];
        const injectable = next[1];

        result[name] = $injector.invoke(injectable);

        return result;
      }, <Dictionary<ColDef[]>>{});

      return new ColumnDefinitionSetService(columnDefinitionSets);
    },
  ];

  private columnDefinitionSets: Dictionary<
    Injectable<(...args: any[]) => ColDef[]>
  > = {};

  addColumnDefinitionSet(
    name: string,
    columns: Injectable<(...args: any[]) => ColDef[]>
  ) {
    this.columnDefinitionSets[name] = columns;
  }
}

export class ColumnDefinitionSetService {
  constructor(private readonly columnDefinitionSets: Dictionary<ColDef[]>) {}

  getColumnDefinitionSet(name: string) {
    return this.columnDefinitionSets[name];
  }
}
